import { ButtonCheckbox, SaveableCard } from "@jasper/forms";
import { Group, Stack, Text, TextInput } from "@mantine/core";
import { withForm } from "../../../hooks/preferenceForm";
import { usePreferenceCardSave } from "../../../hooks/usePreferenceCardSave";
import {
  getGeneralPreferenceDefaults,
  toggleValue,
} from "../generalPreferenceForm";

const LAB_INSTRUCTIONS = [
  "Photo jointe",
  "Antagoniste en résine",
  "Provisoire à conserver",
];

export const LabPreferences = withForm({
  defaultValues: getGeneralPreferenceDefaults(undefined),
  render: function Render({ form }) {
    const { status, save } = usePreferenceCardSave(form, [
      "labInstructions",
      "labNote",
    ]);

    return (
      <SaveableCard
        title="Consignes récurrentes au laboratoire"
        description="Ajoutées à chaque commande · retirables dans le flux"
        status={status}
        onSave={save}
      >
        <Stack gap="s3">
          <>
            <Text variant="strong">Consignes</Text>
            <form.Field name="labInstructions">
              {field => (
                <Group>
                  {LAB_INSTRUCTIONS.map(instruction => (
                    <ButtonCheckbox
                      key={instruction}
                      id={instruction}
                      isActive={field.state.value.includes(instruction)}
                      onClick={() =>
                        field.handleChange(values =>
                          toggleValue(values, instruction)
                        )
                      }
                    >
                      {instruction}
                    </ButtonCheckbox>
                  ))}
                </Group>
              )}
            </form.Field>
          </>
          <>
            <Group gap="s1">
              <Text variant="strong">Note libre au laboratoire</Text>•
              <Text variant="strong" fw="400">
                visible sur toutes vos commandes
              </Text>
            </Group>
            <form.Field name="labNote">
              {field => (
                <TextInput
                  value={field.state.value}
                  onChange={event => field.handleChange(event.target.value)}
                  onBlur={field.handleBlur}
                />
              )}
            </form.Field>
          </>
        </Stack>
      </SaveableCard>
    );
  },
});
